import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./NoRecentLessons.module.scss";

export const NoRecentLessons: VoidFunctionComponent = () => {
  return <p className={s.container}>As you play lessons, the 10 most recent will appear here for quick access.</p>;
}
